<template>
  <div
    v-if="getBundle"
    class="pa-1 caption orange--text"
    style="border-radius: 5px; display: inline-block"
    :style="{
      'background-color': colors.orange.lighten5,
      border: `1px solid ${colors.orange.base}`
    }"
  >
    {{
      `ซื้อ ${getBundle.quantity_condition} ชิ้น ลด ${getBundle.discount} บาท`
    }}
  </div>
</template>

<script>
import colors from 'vuetify/es5/util/colors'
export default {
  props: {
    product: {
      default: undefined
    }
  },
  data() {
    return {
      colors: colors
    }
  },
  computed: {
    getBundle() {
      const bundles = this.$store.getters['bundles/availableBundles']
      const matchBundle = bundles.find((bundle) => {
        return bundle.products.some((product) => product.id == this.product.id)
      })
      return matchBundle
    }
  }
}
</script>

<style lang="scss" scoped></style>
